export default function mainNavigation() {
  const togglButton = document.querySelector('.js-toggle-navigation');
  const mobileNav = document.querySelector('.js-mobile-nav');

  if (mobileNav) {
    const toggleElem = mobileNav.querySelectorAll('.js-toggle-subnav');

    toggleElem.forEach((element) => {
      const subnav = element.parentNode.querySelectorAll('.js-subnav')[0];
      const icon = element.querySelector('.js-toggle');

      element.addEventListener('click', (event) => {
        event.preventDefault();
        element.classList.toggle('t-w700');
        subnav.classList.toggle('mobile-hidden');
        icon.classList.toggle('down');
        icon.classList.toggle('up');
      });
    });
  }

  if (togglButton) {
    const iconBurger = togglButton.querySelector('.js-burger');
    const iconClose = togglButton.querySelector('.js-burger--close');

    mobileNav.classList.add('d-none');
    togglButton.addEventListener('click', () => {
      mobileNav.classList.toggle('d-none');
      iconBurger.classList.toggle('d-none');
      iconClose.classList.toggle('d-none');
    });
  }

  const mainMenuOpenSub = document.querySelectorAll('.o-navigation__item');

  mainMenuOpenSub.forEach((item) => {
    item.addEventListener('click', () => {
      item.querySelector('.open-nav').classList.toggle('d-none');
      item.querySelector('.close-nav').classList.toggle('d-none');
    });
  });
}
